import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputImagem from
    '../common/form/labelAndInputImagem';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm
} from './abastecimentoActions';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    const texto = valor.toString();
    const retorno = Number(
        texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto
    );

    return Number.isFinite(retorno) ? retorno : null;
};

let AbastecimentoForm = props => {
    const formulario = props.formularioValues || {};
    const readOnly = props.excluir ? 'readOnly' : '';
    const quantidade = numero(formulario.quantidade);
    const valorTotal = numero(formulario.valor_total);
    const valorUnitario =
        quantidade > 0 && valorTotal !== null
            ? valorTotal / quantidade
            : 0;
    const veiculoSelecionado = (props.veiculos || []).find(
        item => Number(item.id) === Number(formulario.id_veiculo)
    );

    const alterarOrigem = origem => {
        props.initForm({
            ...formulario,
            origem,
            id_fornecedor:
                origem === 'POSTO'
                    ? formulario.id_fornecedor
                    : null
        });
    };

    const alterarVeiculo = idVeiculo => {
        const veiculo = (props.veiculos || []).find(
            item => Number(item.id) === Number(idVeiculo)
        );

        props.initForm({
            ...formulario,
            id_veiculo: idVeiculo,
            odometro:
                veiculo && veiculo.odometro
                    ? formulario.odometro
                    : null,
            horimetro:
                veiculo && veiculo.horimetro
                    ? formulario.horimetro
                    : null
        });
    };

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Row>
                        <Field
                            name='datahora_abastecimento'
                            component={LabelAndInput}
                            type='datetime-local'
                            label='Data e hora *'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />

                        <Field
                            name='origem'
                            component={Select}
                            options={[
                                { id: 'POSTO', valor: 'Posto' },
                                { id: 'INTERNO', valor: 'Interno' }
                            ]}
                            label='Origem *'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                            value={formulario.origem}
                            onChange={alterarOrigem}
                        />

                        <Field
                            name='id_veiculo'
                            component={Select}
                            options={props.veiculos}
                            label='Veículo *'
                            cols='12 4 4 4'
                            readOnly={readOnly}
                            value={formulario.id_veiculo}
                            onChange={alterarVeiculo}
                        />
                    </Row>

                    <Row>
                        {formulario.origem === 'POSTO' &&
                            <Field
                                name='id_fornecedor'
                                component={Select}
                                options={props.fornecedores}
                                label='Fornecedor *'
                                cols='12 6 5 5'
                                readOnly={readOnly}
                            />}

                        <Field
                            name='id_usuario'
                            component={Select}
                            options={props.usuarios}
                            label='Responsável *'
                            cols='12 6 5 5'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='quantidade'
                            component={LabelAndInputNumber}
                            label='Quantidade (L) *'
                            placeholder='0,000'
                            casas={3}
                            cols='12 3 2 2'
                            readOnly={readOnly}
                        />

                        <Field
                            name='valor_total'
                            component={LabelAndInputNumber}
                            label='Valor total *'
                            placeholder='0,00'
                            casas={2}
                            cols='12 3 2 2'
                            readOnly={readOnly}
                        />

                        <LabelAndInputNumber
                            name='valor_unitario'
                            label='Valor por litro'
                            value={valorUnitario}
                            casas={4}
                            cols='12 3 2 2'
                            readOnly='readOnly'
                            onChange={() => {}}
                        />

                        {veiculoSelecionado &&
                            veiculoSelecionado.odometro &&
                            <Field
                                name='odometro'
                                component={LabelAndInputNumber}
                                label='Odômetro *'
                                casas={0}
                                cols='12 3 2 2'
                                readOnly={readOnly}
                            />}

                        {veiculoSelecionado &&
                            veiculoSelecionado.horimetro &&
                            <Field
                                name='horimetro'
                                component={LabelAndInputNumber}
                                label='Horímetro *'
                                casas={1}
                                cols='12 3 2 2'
                                readOnly={readOnly}
                            />}
                    </Row>

                    <Row>
                        <Field
                            name='numero_nf'
                            component={LabelAndInput}
                            label='Número da NF'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />

                    </Row>

                    <Row>
                        <Field
                            name='imagem_nf'
                            component={LabelAndInputImagem}
                            label='Imagem da NF'
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndTextarea}
                            label='Observação'
                            placeholder='Informe'
                            rows={3}
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>
                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')
                                }
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

AbastecimentoForm = reduxForm({
    form: 'abastecimentoForm',
    destroyOnUnmount: false
})(AbastecimentoForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    formularioValues:
        getFormValues('abastecimentoForm')(state),
    registro: state.abastecimento.registro,
    veiculos: state.abastecimento.veiculos,
    fornecedores: state.abastecimento.fornecedores,
    usuarios: state.abastecimento.usuarios
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AbastecimentoForm);
